import { ChangeDetectionStrategy, Component, HostBinding, Input, TemplateRef } from '@angular/core';
import { Placement } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-control-header',
  templateUrl: './control-header.component.html',
  styleUrls: ['./control-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ControlHeaderComponent {
  @Input()
  label: string;

  @Input()
  isLabelBold = true;

  @Input()
  sublabel: string;

  @Input()
  infoTooltip: string | TemplateRef<any>;

  @Input()
  infoTooltipPlacement: Placement = 'top';

  @Input()
  infoTooltipClass: string;

  @Input()
  keepTooltipOnHover = true;

  @Input()
  index: number;

  @Input()
  labelParamsObj: object;

  @HostBinding('attr.required')
  @Input()
  required: boolean;

  @Input()
  icon: string;

  @Input()
  labelWithColon = true;

  @Input()
  descriptionTooltipText: string;

  @HostBinding('class.opacity-50')
  @Input()
  disabled: boolean;
}
